let Photos2010=[
  {
    "NameEN": "2010",
    "Image": "un36",
    "CaptionEN": "South Sudan celebrates independence day, 2011 [Reuters]",
    "CaptionAR": "جنوب السودان يحتفل باستقلاله عام 2010 (رويترز)"
  },
  {
    "NameEN": null,
    "Image": "un38",
    "CaptionEN": "\"Rocket man is on a suicide mission for himself and for his regime\" - US President Donald Trump on North Korean leader Kim Jong Un, 2017 [AP Photo]",
    "CaptionAR": "الرئيس الأميركي دونالد ترامب أثناء لقائه الزعيم الكوريا الشمالي كيم جونغ أون عام 2017 : \"الرجل الصاروخ في مهمة انتحارية من أجل الدفاع عن نفسه  ونظامه\" (أسوشيتد برس)"
  },
  {
    "NameEN": null,
    "Image": "un37",
    "CaptionEN": "Hundreds of thousands fled Myanmar during the Rohingya crisis, 2017 [Showkat Shafi/Al Jazeera]",
    "CaptionAR": "الآلاف يفرون من ميانمار خلال أزمة الروهينغا عام 2017"
  },
  {
    "NameEN": null,
    "Image": "un35",
    "CaptionEN": "US President Barack Obama speaking at the Climate Summit, 2014 [Getty Images]",
    "CaptionAR": "الرئيس الأميركي باراك أوباما متحدثا في قمة المناخ عام 2017 (غيتي)"
  },
  {
    "NameEN": null,
    "Image": "un34",
    "CaptionEN": "Israeli Prime Minister Benjamin Netanyahu accusing Iran of building a nuclear bomb, 2012 [Getty Images]",
    "CaptionAR": "رئيس الوزراء الإسرائيلي بنيامين نتنياهو يتهم إيران بصناعة قنبلة نووية عام 2012 (غيتي)"
  }
]
export default Photos2010